export default "__VITE_ASSET__65395a5c__"